"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIAlert = _interopRequireDefault(require("./UIAlert"));

var UIFloatingAlert = function UIFloatingAlert(props) {
  var children = props.children,
      className = props.className,
      closeable = props.closeable,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "className", "closeable"]);
  return _react.default.createElement(_UIAlert.default, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-floating-alert', className),
    closeable: closeable
  }), children);
};

UIFloatingAlert.propTypes = (0, _extends2.default)({}, _UIAlert.default.propTypes);
UIFloatingAlert.defaultProps = (0, _extends2.default)({}, _UIAlert.default.defaultProps, {
  closeable: true
});
UIFloatingAlert.displayName = 'UIFloatingAlert';
var _default = UIFloatingAlert;
exports.default = _default;
module.exports = exports.default;